import { useEffect, useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'

import HugcareBackground from '../assets/images/hugcare-background.svg'
import LogoIcon from '../assets/icons/hugcare-logoIcon.svg'
import ListIconOrange from '../assets/icons/hugcare-listIcon_orange.svg'
import ListIconGreen from '../assets/icons/hugcare-listIcon_green.svg'
import ListIconMint from '../assets/icons/hugcare-listIcon_mint.svg'
import HeartIconOrange from '../assets/icons/hugcare-heartIconOrange.svg'
import HeartIconGreen from '../assets/icons/hugcare-heartIconGreen.svg'
import HeartIconMint from '../assets/icons/hugcare-heartIconMint.svg'
import ForwardIcon from '../assets/icons/forward-icon.svg'
import BackwardIcon from '../assets/icons/backward-icon.svg'
import BubbleGreen from '../assets/icons/hugcare-bubble_green.svg'
import BubbleMint from '../assets/icons/hugcare-bubble_mint.svg'
import { hugcareSolutionList } from 'assets/data'
import { hugcareTeacherList } from 'assets/data'
import { hugcareFriendsList } from 'assets/data'
import HugcareFloatingButton from 'components/HugcareFloatingButton'

export default function Hugcare() {
  const [direction, setDirection] = useState(1)
  const [solutionIndex, setSolutionIndex] = useState(0)
  const [teacherIndex, setTeacherIndex] = useState(0)
  const [friendsIndex, setFriendsIndex] = useState(0)

  const handlePrev = (dataList, index, setIndex) => {
    setDirection(-1)
    if (index > 0) {
      setIndex(index - 1)
    }
    if (index === 0) {
      setIndex(dataList.length - 1)
    }
  }

  const handleNext = (dataList, index, setIndex) => {
    setDirection(1)
    if (index < dataList.length - 1) {
      setIndex(index + 1)
    }
    if (index === dataList.length - 1) {
      setIndex(0)
    }
  }

  const windowWidth = () => {
    return window.innerWidth
  }

  const variants = {
    initial: (direction) => {
      return {
        opacity: 0,
        x: direction > 0 ? windowWidth() : -windowWidth(),
      }
    },
    animate: {
      opacity: 1,
      x: 0,
    },
    exit: (direction) => {
      return {
        opacity: 0,
        x: direction > 0 ? -windowWidth() : windowWidth(),
      }
    },
  }

  const opacityVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  }

  const [width, setWidth] = useState(window.innerWidth)

  const handleResize = () => {
    setWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      setSolutionIndex((solutionIndex + 1) % hugcareSolutionList.length)
      setTeacherIndex((teacherIndex + 1) % hugcareTeacherList.length)
      setFriendsIndex((friendsIndex + 1) % hugcareFriendsList.length)
    }, 3000)

    return () => clearInterval(interval)
  }, [solutionIndex, teacherIndex, friendsIndex])

  return (
    <div className='wrapper'>
      <div className='overflow-hidden mb-[-220px] sm:mb-[-260px]'>
        {/* 메인 */}
        <div className='relative hugcare_background'>
          <div className='h-[600px] sm:h-[800px] container  flex items-center justify-center mx-auto'>
            <div className='z-20 flex flex-col items-center justify-center gap-12'>
              <motion.p
                initial={{ y: -50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 1 }}
                className='text-title1-bold lg:text-display2-bold 2xl:text-display1-bold text-sk-white'
              >
                허그케어
              </motion.p>
              <motion.p
                initial={{ y: -50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.5, duration: 1 }}
                className='text-title3-medium lg:text-title2-medium 2xl:text-title1-medium text-sk-white'
              >
                오늘의 마음의 온도는 몇 도 인가요?
              </motion.p>
            </div>
            <motion.img
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3, duration: 2 }}
              className='absolute bottom-0 md:right-0'
              src={HugcareBackground}
              alt=''
            />
          </div>
        </div>
        {/* 허그케어 */}
        <div className='container flex flex-col items-start justify-center px-20 mx-auto sm:pl-40 py-30 sm:py-40'>
          <div className='flex flex-col items-start gap-16'>
            <p className='text-title3-bold lg:text-title2-bold 2xl:text-title1-bold text-sk-black'>
              허그케어
            </p>
            <p className='text-body1-medium sm:text-h2-medium text-sk-info'>
              학생 및 교직원 심리상담, 진로 진학 상담 키오스크 소프트웨어 구축 및 배포, 유지보수
            </p>
          </div>
        </div>
        {/* HUGCARE-KIOSK */}
        <div className='container items-center justify-center gap-40 py-48 mx-auto sm:flex max-sm:flex max-sm:flex-col sm:py-64 sm:gap-80 max-sm:px-20'>
          <img src={require('assets/images/hugcare-image1.png')} alt='' />
          <div className='flex flex-col items-start gap-24 sm:gap-48 xl:px-80 lg:pl-80'>
            <div className='flex flex-col items-start gap-10'>
              <p className='text-title3-bold sm:text-title2-bold text-sk-hugcare'>HUGCARE-KIOSK</p>
              <p className='text-h2-medium sm:text-h1-medium text-sk-black'>
                교원 및 교우보호를 위한 심리검사 및 상담AI 키오스크
              </p>
            </div>
            <div className='flex flex-col items-start gap-10 sm:gap-16 max-w-[630px]'>
              <p className='text-body2-long-regular sm:text-body1-long-regular text-sk-black'>
                우울, 불안, 자해, 자살, 직무 스트레스 등 마음건강 자가 검진 및 상담 시스템을
                제공하는 HUGCARE-KIOSK는 교원과 학생 마음건강 보호를 위해 개발한 심리 검사 및 상담
                AI 키오스크입니다
              </p>
              <p className='text-body2-long-regular sm:text-body1-long-regular text-sk-black'>
                다양한 요인으로 발생하는 교원과 학생의 마음건강 악화를 사전적으로 예방할 수 있으며,
                교육기관과 전문 상담센터와 연계하여 O2O(Online to Offline) 통합 지원형 예방 인프라
                구축을 지원합니다
                <br />
                학생 진로 설계 및 채용 공고 조회, 두뇌 게임 등 기관 맞춤형 추가 기능을 제공합니다
              </p>
            </div>
          </div>
        </div>

        {/* 허그케어만의 특장점 */}
        <div className='bg-neutral-99'>
          <div className='container flex flex-col items-center justify-center w-full gap-24 mx-auto py-60 sm:py-80 max-sm:px-20'>
            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 1 }}
              className='text-title2-bold sm:text-title1-bold text-sk-black'
            >
              허그케어만의 특장점
            </motion.p>
            <div className='flex flex-col sm:grid sm:grid-cols-2 gap-x-20 gap-y-24'>
              <div className='flex flex-col gap-12 p-28 bg-sk-white shadow-emphasize rounded-12 max-w-[502px] sm:h-[341px]'>
                <div className='flex flex-col items-start gap-2'>
                  <p className='text-body1-long-semibold sm:text-h2-semibold text-sk-info'>01</p>
                  <p className='max-2xs:text-h2-semibold 2xs:text-h1-semibold sm:text-title3-bold text-sk-default'>
                    교원, 학생 모두를 위한 <br />
                    마음건강 치유 솔루션
                  </p>
                </div>
                <p className='text-body2-long-regular text-sk-info'>
                  하나의 키오스크로 사용자에 따라 허그케어 선생님용(허그티처), 학생용(허그프렌즈) 두
                  가지 서비스를 이용할 수 있습니다
                  <br />
                  키오스크를 활용한 내용을 어플을 통해 휴대전화에서 확인하고 마음 건강 변화 추이도
                  관찰할 수 있습니다
                </p>
              </div>
              <div className='flex flex-col gap-12 p-28 bg-sk-white shadow-emphasize rounded-12 max-w-[502px] sm:h-[341px]'>
                <div className='flex flex-col items-start gap-2'>
                  <p className='text-body1-long-semibold sm:text-h2-semibold text-sk-info'>02</p>
                  <p className='max-2xs:text-h2-semibold 2xs:text-h1-semibold sm:text-title3-bold text-sk-default'>
                    대화형 AI 허그봇을 이용한 <br />
                    문답형 자가학습
                  </p>
                </div>
                <p className='text-body2-long-regular text-sk-info'>
                  공신력 있는 데이터 기반 AI챗봇 기능을 지원합니다
                  <br />
                  내장된 마이크로 친구, 상담사와 대화하듯이 말을 걸면 사용자의 고민과 상황에 적합한
                  위로와 적절한 조언을 건내줍니다
                </p>
              </div>
              <div className='flex flex-col gap-12 p-28 bg-sk-white shadow-emphasize rounded-12 max-w-[502px] sm:h-[341px]'>
                <div className='flex flex-col items-start gap-2'>
                  <p className='text-body1-long-semibold sm:text-h2-semibold text-sk-info'>03</p>
                  <p className='max-2xs:text-h2-semibold 2xs:text-h1-semibold sm:text-title3-bold text-sk-default'>
                    지정 상담센터 연계로 <br />
                    전문 화상 상담 지원
                  </p>
                </div>
                <p className='text-body2-long-regular text-sk-info'>
                  자가검진 결과 전문가의 상담이 필요한 경우 혹은 사용자가 상담을 원하는 경우
                  키오스크에서 전문 상담사와 상담을 신청하고, 실시간 화상 상담으로 심리적 지원을
                  받을 수 있습니다
                </p>
              </div>
              <div className='flex flex-col gap-12 p-28 bg-sk-white shadow-emphasize rounded-12 max-w-[502px] sm:h-[341px]'>
                <div className='flex flex-col items-start gap-2'>
                  <p className='text-body1-long-semibold sm:text-h2-semibold text-sk-info'>04</p>
                  <p className='max-2xs:text-h2-semibold 2xs:text-h1-semibold sm:text-title3-bold text-sk-default'>
                    학생의 진로설계 <br />
                    학습 콘텐츠 제공
                  </p>
                </div>
                <p className='text-body2-long-regular text-sk-info'>
                  워크넷 기반 실시간 채용정보를 활용하여 다양한 취업 콘텐츠를 제공합니다
                  <br />
                  학생의 관심 직무, 지역, 고용 형태에 따라 적합한 진로 채용 정보를 활용, 기록할 수
                  있습니다
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 허그케어 - 솔루션 */}
        {/* 배너 */}
        <div className='w-full bg-sk-hugcare'>
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 1 }}
          >
            <div className='container flex items-center justify-between mx-auto sm:py-48 max-sm:px-24 2xs:py-36 max-2xs:py-24'>
              <div className='flex items-center justify-center gap-8'>
                <p className='max-2xs:text-title2-bold 2xs:text-title1-bold xl:text-display2-bold text-sk-white'>
                  허그케어
                </p>
                <p className='max-2xs:text-title3-medium 2xs:text-title2-medium xl:text-title1-medium text-sk-disable'>
                  솔루션
                </p>
              </div>
              <img src={LogoIcon} alt='' />
            </div>
          </motion.div>
        </div>
        {/* 캐러셀 */}
        <div className='container relative mx-auto h-[670px] 2xs:h-[750px] sm:h-[900px] lg:h-[670px]'>
          {hugcareSolutionList.map((solutionItem, index) => (
            <div key={index} className='flex flex-col items-start bg-sk-white'>
              <div
                className={`flex justify-between absolute w-0 pt-40 2xs:pt-60 lg:pt-80 ${
                  solutionIndex === index ? 'w-full pl-40 pr-10' : 'overflow-hidden'
                }`}
              >
                <div className='relative py-16 pl-32 pr-12 2xs:pr-24 2xs:pl-64 button_default bg-sk-hugcare sm:pr-36 '>
                  <img
                    className='absolute -left-30 size-[60px] 2xs:size-[80px]'
                    src={HeartIconOrange}
                    alt=''
                  />
                  <motion.p
                    key={solutionIndex}
                    variants={opacityVariants}
                    initial='hidden'
                    animate='visible'
                    transition={{ duration: 0.5 }}
                    className='text-body2-semibold 2xs:text-h2-semibold sm:text-h1-semibold text-sk-white'
                  >
                    {solutionItem.title}
                  </motion.p>
                </div>
                <div className='flex items-center gap-10 2xs:gap-16 sm:gap-32'>
                  <button
                    onClick={() => handlePrev(hugcareSolutionList, solutionIndex, setSolutionIndex)}
                  >
                    <img src={BackwardIcon} className='size-[36px] 2xs:size-[48px]' alt='' />
                  </button>
                  <button
                    onClick={() => handleNext(hugcareSolutionList, solutionIndex, setSolutionIndex)}
                  >
                    <img src={ForwardIcon} className='size-[36px] 2xs:size-[48px]' alt='' />
                  </button>
                </div>
              </div>
              <AnimatePresence custom={direction}>
                <motion.div
                  key={solutionIndex}
                  custom={direction}
                  variants={variants}
                  initial='initial'
                  animate='animate'
                  exit='exit'
                  transition={{
                    x: { type: 'spring', stiffness: 300, damping: 30 },
                    duration: 0.5,
                    opacity: { duration: 0.5 },
                  }}
                >
                  <div
                    className={`flex max-lg:flex-col lg:gap-[78px] gap-32 absolute left-0 top-[150px] lg:top-[180px] w-0 h-[400px] ${
                      solutionIndex === index ? 'w-screen' : 'overflow-hidden'
                    }`}
                  >
                    <img src={solutionItem.img} className='px-20 size-fit' alt='' />
                    <div className='flex flex-col items-start lg:items-end lg:justify-end md:h-[400px] py-20 lg:gap-0 gap-30 pl-30 pr-20'>
                      <div className='flex flex-col gap-16 text-start 2xs:gap-30'>
                        <p className='text-h1-semibold 2xs:text-title3-bold sm::text-title2-bold text-sk-default'>
                          {solutionItem.subTitle}
                        </p>
                        <ul
                          className='flex flex-col gap-6 2xs:gap-12 text-start'
                          style={{ listStyleImage: `url(${ListIconOrange})` }}
                        >
                          {solutionItem.description.map((contentItem, contentIndex) => (
                            <li
                              key={contentIndex}
                              className='whitespace-pre-wrap text-body2-long-regular 2xs:text-body1-long-regular text-sk-sub'
                            >
                              {width <= 640
                                ? contentItem.content.replace('\n', '')
                                : contentItem.content}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>
          ))}
        </div>
        {/* 허그티처 */}
        {/* 배너 */}
        <div className='w-full bg-[#51C671]'>
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 1 }}
          >
            <div className='container flex items-center justify-between mx-auto sm:py-48 max-sm:px-24 2xs:py-36 max-2xs:py-24'>
              <div className='flex items-center justify-center'>
                <p className='max-2xs:text-title2-bold 2xs:text-title1-bold xl:text-display2-bold text-sk-white'>
                  허그티처
                </p>
              </div>
              <img src={LogoIcon} alt='' />
            </div>
          </motion.div>
        </div>
        {/* 교사 우울정도 설문조사 결과 */}
        <div className='container flex justify-center mx-auto'>
          <div className='flex flex-col justify-center gap-20 py-60 sm:py-80 sm:gap-28 max-sm:px-20'>
            <div className='relative sm:py-16 sm:px-36 py-12 px-28 flex justify-center items-center rounded-80 max-w-[260px] sm:max-w-[340px] bg-[#C0E0BB]'>
              <p className='text-h2-semibold sm:text-h1-semibold text-sk-default'>
                교사 우울정도 설문조사 결과
              </p>
              <img className='absolute -bottom-[15px] left-[57px]' src={BubbleGreen} alt='' />
            </div>
            <div className='flex flex-col items-end gap-20'>
              <img
                className='py-30 lg:px-[130px] xl:px-[320px] flex items-center'
                src={require('../assets/images/hugcare-image2.png')}
                alt=''
              />
              <p className='flex items-end max-2xs:text-body3-medium 2xs:text-body2-medium sm:text-body1-medium text-sk-assistive'>
                자료 출처) 전국교직원노동조합, 녹색병원
              </p>
            </div>
            <img src={require('../assets/images/hugcare-effect1.png')} alt='' />
            <div className='flex flex-col items-center'>
              <div className='relative '>
                <p className='text-center max-2xs:text-h1-semibold 2xs:max-2xs:text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold md:text-title1-bold text-sk-default'>
                  숨겨진 침해까지 고려시
                  <br />
                  이미 교실현장은 교육활동 침해로 만연한 상황
                </p>
                <img
                  className='absolute -right-10 -bottom-10 -z-10'
                  src={require('../assets/images/hugcare-effect2.png')}
                  alt=''
                />
              </div>
            </div>
          </div>
        </div>
        {/* 교육활동 침해 시 교사의 대응 */}
        <div className='container flex justify-center mx-auto'>
          <div className='flex flex-col justify-center gap-20 py-60 sm:py-80 sm:gap-28 max-sm:px-20'>
            <div className='relative sm:py-16 sm:px-36 py-12 px-28 flex justify-center items-center rounded-80 max-w-[260px] sm:max-w-[340px] bg-[#C0E0BB]'>
              <p className='text-h2-semibold sm:text-h1-semibold text-sk-default'>
                교육활동 침해 시 교사의 대응
              </p>
              <img className='absolute -bottom-[15px] left-[57px]' src={BubbleGreen} alt='' />
            </div>
            <div className='flex flex-col items-end gap-20'>
              <img
                className='py-20 sm:py-80 lg:px-[115px] xl:px-[245px]'
                src={require('../assets/images/hugcare-image3.png')}
                alt=''
              />
              <p className='text-body2-medium sm:text-body1-medium text-sk-assistive'>
                자료 출처) 2022년, 한국교총
              </p>
            </div>
            <img src={require('../assets/images/hugcare-effect1.png')} alt='' />
            <div className='flex items-center justify-center'>
              <div className='relative'>
                <p className='text-center max-2xs:text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold md:text-title1-bold text-sk-default'>
                  힘들어도 대화를 나눌 상대가 없어 <br />
                  해결 방법이 없습니다
                </p>
                <img
                  className='absolute -right-30 top-20 -z-10'
                  src={require('../assets/images/hugcare-effect2.png')}
                  alt=''
                />
              </div>
            </div>
          </div>
        </div>

        <div className='container flex items-start mx-auto py-60 sm:py-80 max-sm:px-20'>
          <p className='max-2xs:text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold md:text-title1-bold text-[#36AD56]'>
            우리가 힘들 때 말이라도 들어줄 상대가 있다면, <br className='hidden sm:block' />
            얼마나 좋을까요?
          </p>
        </div>
        {/* 캐러셀 */}
        <div className='container relative mx-auto h-[670px] 2xs:h-[770px] sm:h-[1020px] lg:h-[800px]'>
          {hugcareTeacherList.map((teacherItem, index) => (
            <div key={index} className='flex flex-col items-start bg-sk-white'>
              <div
                className={`flex justify-between absolute w-0 pt-40 lg:pt-80  ${
                  teacherIndex === index ? 'w-full pl-40 pr-10' : 'overflow-hidden'
                }`}
              >
                <div className='relative py-16 pl-32 pr-24 2xs:pl-64 button_default bg-[#51C671] sm:pr-36 '>
                  <img
                    className='absolute -left-30 size-[60px] 2xs:size-[80px]'
                    src={HeartIconGreen}
                    alt=''
                  />
                  <motion.p
                    key={teacherIndex}
                    variants={opacityVariants}
                    initial='hidden'
                    animate='visible'
                    transition={{ duration: 0.5 }}
                    className='text-h2-semibold 2xs:text-h1-semibold text-sk-white'
                  >
                    {teacherItem.title}
                  </motion.p>
                </div>
                <div className='flex items-center gap-16 sm:gap-32'>
                  <button
                    onClick={() => handlePrev(hugcareTeacherList, teacherIndex, setTeacherIndex)}
                  >
                    <img src={BackwardIcon} className='size-[36px] 2xs:size-[48px]' alt='' />
                  </button>
                  <button
                    onClick={() => handleNext(hugcareTeacherList, teacherIndex, setTeacherIndex)}
                  >
                    <img src={ForwardIcon} className='size-[36px] 2xs:size-[48px]' alt='' />
                  </button>
                </div>
              </div>
              <AnimatePresence custom={direction}>
                <motion.div
                  key={teacherIndex}
                  custom={direction}
                  variants={variants}
                  initial='initial'
                  animate='animate'
                  exit='exit'
                  transition={{
                    x: { type: 'spring', stiffness: 300, damping: 30 },
                    duration: 0.5,
                    opacity: { duration: 0.5 },
                  }}
                >
                  <div
                    className={`flex max-lg:flex-col lg:gap-[78px] 2xs:gap-32 absolute top-[120px] lg:top-[180px] w-0 h-[560px] ${
                      teacherIndex === index
                        ? 'w-screen items-center 2xs:items-start lg:items-end'
                        : 'overflow-hidden'
                    }`}
                  >
                    <img src={teacherItem.img} className='px-20' alt='' />
                    <div className='flex flex-col items-start lg:items-end lg:justify-end md:h-[400px] py-20 lg:gap-0 gap-30 pl-30 pr-20'>
                      <div className='flex flex-col gap-16 text-start 2xs:gap-30'>
                        <p className='text-h1-semibold 2xs:text-title3-bold sm::text-title2-bold text-sk-default'>
                          {teacherItem.subTitle}
                        </p>
                        <ul
                          className='flex flex-col gap-6 2xs:gap-12 text-start'
                          style={{ listStyleImage: `url(${ListIconGreen})` }}
                        >
                          {teacherItem.description.map((contentItem, contentIndex) => (
                            <li
                              key={contentIndex}
                              className='whitespace-pre-wrap text-body2-long-regular 2xs:text-body1-long-regular text-sk-sub'
                            >
                              {width <= 640
                                ? contentItem.content.replace(/\n/g, '')
                                : contentItem.content}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>
          ))}
        </div>

        {/* 허그프렌즈 */}
        {/* 배너 */}
        <div className='w-full bg-[#48C3A6]'>
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 1 }}
          >
            <div className='container flex items-center justify-between mx-auto sm:py-48 max-sm:px-24 2xs:py-36 max-2xs:py-24'>
              <div className='flex items-center justify-center'>
                <p className='max-2xs:text-title2-bold 2xs:text-title1-bold xl:text-display2-bold text-sk-white'>
                  허그프렌즈
                </p>
              </div>
              <img src={LogoIcon} alt='' />
            </div>
          </motion.div>
        </div>
        {/* 학교폭력 실태 설문조사 결과 */}
        <div className='container flex items-center justify-center mx-auto'>
          <div className='flex flex-col justify-center gap-20 py-60 sm:py-80 sm:gap-28 max-sm:px-20'>
            <div className='relative sm:py-16 sm:px-36 py-12 px-28 flex justify-center items-center rounded-80 max-w-[260px] sm:max-w-[340px] bg-[#BFE3D9]'>
              <p className='text-h2-semibold sm:text-h1-semibold text-sk-default'>
                학교폭력 실태 설문조사 결과
              </p>
              <img className='absolute -bottom-[15px] left-[57px]' src={BubbleMint} alt='' />
            </div>
            <img
              className='py-20 xl:px-[167px]'
              src={require('../assets/images/hugcare-image4.png')}
              alt=''
            />
          </div>
        </div>
        {/* 학교폭력 피해로 인한 고통 */}
        <div className='container flex items-center justify-center mx-auto'>
          <div className='flex flex-col justify-center gap-20 py-60 sm:py-80 sm:gap-28 max-sm:px-20'>
            <div className='relative sm:py-16 sm:px-36 py-12 px-28 flex justify-center items-center rounded-80 max-w-[260px] sm:max-w-[340px] bg-[#BFE3D9]'>
              <p className='text-h2-semibold sm:text-h1-semibold text-sk-default'>
                학교폭력 피해로 인한 고통
              </p>
              <img className='absolute -bottom-[15px] left-[57px]' src={BubbleMint} alt='' />
            </div>
            <div className='flex flex-col items-center'>
              <img className='py-20' src={require('../assets/images/hugcare-image5.png')} alt='' />
            </div>
            <img src={require('../assets/images/hugcare-effect3.png')} alt='' />
            <div className='flex items-center justify-center'>
              <p className='text-center max-2xs:text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold md:text-title1-bold text-sk-default'>
                학교폭력, 따돌림. 남의 문제가 아닙니다
              </p>
            </div>
          </div>
        </div>

        <div className='container flex items-start mx-auto py-80 max-sm:px-20'>
          <p className='max-2xs:text-h1-semibold 2xs:text-title3-bold sm:text-title2-bold md:text-title1-bold text-[#4CA891]'>
            학생의 마음건강을 보호하고 정신건강 . 자살 . 자해 위기학생을 <br />
            조기발견하고 지원할 때 입니다
          </p>
        </div>
        {/* 캐러셀 */}
        <div className='container relative mx-auto h-[700px] 2xs:h-[820px] sm:h-[1050px] lg:h-[800px]'>
          {hugcareFriendsList.map((friendsItem, index) => (
            <div key={index} className='flex flex-col items-start bg-sk-white sm:px-0'>
              <div
                className={`flex justify-between absolute w-0 pt-40 lg:pt-80  ${
                  friendsIndex === index ? 'w-full pl-40 pr-10' : 'overflow-hidden'
                }`}
              >
                <div className='relative py-16 pl-32 pr-24 2xs:pl-64 button_default bg-[#48C3A6] sm:pr-36 '>
                  <img
                    className='absolute -left-30 size-[60px] 2xs:size-[80px]'
                    src={HeartIconMint}
                    alt=''
                  />
                  <motion.p
                    key={friendsIndex}
                    variants={opacityVariants}
                    initial='hidden'
                    animate='visible'
                    transition={{ duration: 0.5 }}
                    className='text-h2-semibold 2xs:text-h1-semibold text-sk-white'
                  >
                    {friendsItem.title}
                  </motion.p>
                </div>
                <div className='flex items-center gap-16 sm:gap-32'>
                  <button
                    onClick={() => handlePrev(hugcareFriendsList, friendsIndex, setFriendsIndex)}
                  >
                    <img src={BackwardIcon} className='size-[36px] 2xs:size-[48px]' alt='' />
                  </button>
                  <button
                    onClick={() => handleNext(hugcareFriendsList, friendsIndex, setFriendsIndex)}
                  >
                    <img src={ForwardIcon} className='size-[36px] 2xs:size-[48px]' alt='' />
                  </button>
                </div>
              </div>
              <AnimatePresence custom={direction}>
                <motion.div
                  key={friendsIndex}
                  custom={direction}
                  variants={variants}
                  initial='initial'
                  animate='animate'
                  exit='exit'
                  transition={{
                    x: { type: 'spring', stiffness: 300, damping: 30 },
                    duration: 0.5,
                    opacity: { duration: 0.5 },
                  }}
                >
                  <div
                    className={`flex max-lg:flex-col lg:gap-[78px] 2xs:gap-32 absolute top-[120px] lg:top-[180px] w-0 h-[560px] ${
                      friendsIndex === index
                        ? 'w-screen items-center 2xs:items-start lg:items-end'
                        : 'overflow-hidden'
                    }`}
                  >
                    <img src={friendsItem.img} className='px-20' alt='' />
                    <div className='flex flex-col items-start lg:items-end  md:h-[400px] py-20 lg:gap-0 gap-30 pl-30 pr-20'>
                      <div className='flex flex-col gap-16 text-start 2xs:gap-30'>
                        <p className='text-h1-semibold 2xs:text-title3-bold sm::text-title2-bold text-sk-default'>
                          {friendsItem.subTitle}
                        </p>
                        <ul
                          className='flex flex-col gap-6 2xs:gap-12 text-start'
                          style={{ listStyleImage: `url(${ListIconMint})` }}
                        >
                          {friendsItem.description.map((contentItem, contentIndex) => (
                            <li
                              key={contentIndex}
                              className='whitespace-pre-wrap text-body2-long-regular 2xs:text-body1-long-regular text-sk-sub'
                            >
                              {width <= 640
                                ? contentItem.content.replace(/\n/g, '')
                                : contentItem.content}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
      <HugcareFloatingButton />
    </div>
  )
}
